import { DocumentCategoryType } from '@smiles/core-account/dist/Types/CommonTypes';
import { IValidateDocumentStatusServiceResponse, ValidateDocumentStatusData } from '@smiles/core-account/dist/Types/ValidateDocumentStatus.types';
import { getCookieByKey } from '../../utils/cookieUtils';
import { IFinalResponse, checkEnv, UtilsServices, AccountServices, AccountHelpers } from './config';

export const validateDocument = async (
  type: any,
  value: string,
  tokenRecaptcha = undefined as string | undefined,
): Promise<IFinalResponse> => {
  return AccountServices.validateDocument({
    type,
    value,
    tokenRecaptcha: checkEnv() === 'MOCK' ? undefined : tokenRecaptcha,
  });
};

export type ILoginTypes = 'MEMBER' | 'CPF' | 'EMAIL';
interface IValidateDocumentStatusRequest {
  type: ILoginTypes;
  documentType?: string;
  value: string;
  recaptcha: string;
}

interface IMakeRequestFunction {
  value?: string;
  type?: string;
}

type CustomValidateDocumentStatusResponseData = ValidateDocumentStatusData & {
  acceptTerm: boolean;
  first: boolean;
  sourceBrand: 0 | 1;
  type: 0 | 1 | 2 | 3;
}

type CustomValidateDocumentStatusResponse = IValidateDocumentStatusServiceResponse & {
  data?: CustomValidateDocumentStatusResponseData
}

export const validateDocumentStatus = async ({
  type,
  value,
  recaptcha,
}: IValidateDocumentStatusRequest): Promise<CustomValidateDocumentStatusResponse> => {
  const makeRequest = {
    MEMBER: (request: IMakeRequestFunction) => ({
      memberNumber: request.value,
    }),
    CPF: (request: IMakeRequestFunction) => ({
      type: request.type,
      value: request.value,
    }),
    EMAIL: (request: IMakeRequestFunction) => ({
      email: request.value,
    }),
  };

  const body = makeRequest[type]({
    type,
    value,
  });

  // console.log('body', body)

  return AccountServices.validateDocumentStatus({
    ...body,
    tokenRecaptcha: recaptcha,
  });
};

interface IValidateDocumentStatusRequestV2 {
  type: ILoginTypes;
  documentType?: string;
  value: string;
}

type ValidateDocumentStatusV2Data = {
    countPasswordLock?: number;
    status: string;
    smilesToken?: string;
    realStatus?: string;
    lastLogin?: string;
    openedSr?: boolean;
    acceptTerm: boolean;
    first: boolean;
    sourceBrand: number;
};

interface IValidateDocumentStatusV2ServiceResponse extends IFinalResponse {
    data?: ValidateDocumentStatusV2Data;
}

export const validateDocumentStatusV2 = async ({
  type,
  value,
}: IValidateDocumentStatusRequestV2): Promise<IValidateDocumentStatusV2ServiceResponse> => {
  const makeRequest = {
    MEMBER: (request: IMakeRequestFunction) => ({
      memberNumber: request.value,
    }),
    CPF: (request: IMakeRequestFunction) => ({
      type: request.type,
      value: request.value,
    }),
    EMAIL: (request: IMakeRequestFunction) => ({
      email: request.value,
    }),
  };

  const body = makeRequest[type]({
    type,
    value,
  });

  return AccountServices.validateDocumentStatusV2({
    ...body,
  });
};